const Mousetrap = require('mousetrap');

import {MapOfArrays} from "./classes/MapOfArrays";

// key => array of handlers
const _keys = new MapOfArrays();

// wrapper around Mousetrap
export class Shortcuts {

    // same as Mousetrap.bind EXCEPT it does not override previous handlers
    static bind(keys, callback) {

        if (typeof callback !== 'function') {
            return;
        }

        // first time registering this key?
        if (_keys.get(keys) == null) {

            Mousetrap.bind(keys, () => {

                (_keys.get(keys) || []).forEach((callback) => {
                    callback();
                });

            });
        }

        // append as another handle for this key
        _keys.push(keys, callback);
    }
}